import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ReportsServiceProvider } from '../../api/reports'

const ReportsService = ReportsServiceProvider()
const name = 'bulkReportsDownloadPDF'

export default ({ campaignId, fileName }) => (asyncAction(
  name,
  ReportsService.bulkReportsDownloadPDF,
  { campaignId, fileName }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/reports/bulkReportsDownloadPDF.js